import React from 'react';
import { connect } from 'react-redux'
import { purgeItem, pushItem, qItem, deleteItem, startDraftItem, setItemField } from '../../actions/InventoryActions';
import { stateForDoc } from '../../lib/inventory-util';

import ActionVal from '../containers/ActionVal';
import BareInput from '../elements/BareInput';
import DateVal from '../containers/DateVal';
import Draft from '../../lib/draft.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RectButton from '../elements/RectButton';
import Separator from '../elements/Separator';
import ImageLayout from '../layouts/ImageLayout';

import { dot } from '../../lib/obj';
import { singularType } from '../../constants/inventory/Types'
import { datify } from '../../lib/formats';
import { _ } from '../../lib/underscore';

import './FlexForm.scss';

const DOUBLE_CLICK_MS_LIMIT = 200;
const STATUS_WORKING = {
  creating: true,
  saving: true,
  deleting: true
};

class FlexForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      texts: {},
      editing: props.editing || false,
      statuses: {}
    };
    this._clicks = {};
  }

  renderField(item, conf, index) {
    let val = dot(item.data, conf.field);
    if (val === undefined) { val = conf.default; }
    let el;
    switch (conf.type) {
      case "action":
        el = <ActionVal onClick={(e, h) => { conf.onClick(e, h, item) }} data-hype={conf.hype}>{conf.mod ? conf.mod(val) : val}</ActionVal>
        break;
      case "string":
        el = <BareInput defaultValue={val} onBlurOrEnter={(e) => { this.saveField(conf, e.target.value, val, index) }} onChange={(e, dirty) => { this.onInputChange(e, dirty, index) }} />
        break;
      case "date":
        let dateVal = Date.utcTransDateInput(val);
        el = <BareInput type="date" data-hype={dateVal ? "" : "blank"} defaultValue={dateVal} onChange={(e) => { this.saveDateField(conf, e.target.value, dateVal) }} />
        break;
      case "number":
        el = <BareInput defaultValue={val} type="number" onBlurOrEnter={(e) => { this.saveField(conf, e.target.value, val, index) }} />
        break;
      case "money":
        el = <BareInput step="0.01" defaultValue={val} type="number" onBlurOrEnter={(e) => { this.saveField(conf, e.target.value, val, index) }} />
        break;
      case "image":
        el = <ImageLayout file={val} onUpload={(file) => this.saveImage(conf, file, val)} />
        break;
      case "dropdown":
        let options = conf.options || [];
        console.log("------ Dropdown value:", conf.title, val);
        el = <select defaultValue={val} onChange={(e) => { this.saveField(conf, e.target.value, val, index) }} data-hype={val || 'undefined'}>
          {options.map((v, i) => { return <option key={`option${i}`} value={v.value}>{v.name}</option> })}
        </select>
        break;
      case "text":
        el = this.genTextDiv(conf, item, val);
        break;
      case "custom":
        el = conf.render ? conf.render(item) : "-";
        break;
      case "plain":
      default:
        el = <div className="PlainVal">{val}</div>
    }
    return el;
  }

  renderReadOnlyField(item, conf) {
    let val = dot(item.data, conf.field);
    let el;
    switch (conf.type) {
      case "action":
        el = <ActionVal onClick={(e, h) => { conf.onClick(e, h, item) }} data-hype={conf.hype}>{conf.mod ? conf.mod(val) : val}</ActionVal>
        break;
      case "date":
        el = <div className="PlainVal">{datify(val)}</div>;
        break;
      case "image":
        el = <ImageLayout file={val} />
        break;
      case "dropdown":
        let options = conf.options || [];
        el = <select defaultValue={val} onChange={(e) => { this.saveField(conf, e.target.value, val) }} data-hype={val || 'undefined'} disabled>
          {options.map((v, i) => { return <option key={`option${i}`} value={v.value}>{v.name}</option> })}
        </select>
        break;
      case "text":
        el = this.genTextDiv(conf, item, val);
        break;
      case "custom":
        el = conf.render ? conf.render(item) : "-";
        break;
      case "plain":
      default:
        if (conf.onClick) {
          el = <ActionVal onClick={(e, h) => { conf.onClick(e, h, item) }} data-hype={conf.hype}>{conf.mod ? conf.mod(val) : val}</ActionVal>
        }
        else {
          el = <div className="PlainVal">{val}</div>
        }
    }
    return el;
  }

  genControlsDiv(item) {
    let data = item.data || {};
    if (data.id > 0) {
      let controls = this.props.controls || [];
      return <details className="FloatDetails">
        <summary onClick={(e) => { this.onControlClick(e, item) }}>
          <FontAwesomeIcon className="ControlIcon" icon={["fal", "ellipsis-v"]} />
        </summary>
        <div className="DetailsList">
          <div className="Header">ID:{data.id} <aside><DateVal>{data.createdAt}</DateVal></aside></div>
          <Separator collapsed={true} />
          {controls.map((conf, i) => {
            return <div className="IconAction" onClick={() => { this.onControl(conf, item) }}>
              <FontAwesomeIcon icon={conf.icon || ["far", "square-minus"]} /> {conf.title}
            </div>
          })}
          <RectButton working={item.status == "deleting"} theme="red" onClick={(e, history) => { this.onDeleteItem(e, item.data.id) }}>Delete</RectButton>
        </div>
      </details>
    } else {
      return <FontAwesomeIcon className="ControlIcon" icon={["far", "times"]} onClick={(e) => { this.onDeleteItem(e, item.data.id) }} />
    }
  }

  genTextDiv(conf, item, val) {
    if (item) {
      let txt = dot(this.state, ["texts", conf.field]);
      let edited = txt != null && txt != val;
      return <details className="FloatDetails">
        <summary>
          <FontAwesomeIcon className="Icon" icon={["far", "memo-pad"]} data-filled={val ? true : false} />
        </summary>
        <div className="DetailsList">
          <textarea name="notes" style={{ width: "100%", minHeight: "10em" }} defaultValue={val} onChange={(e) => this.onTextChange(e, conf)}></textarea>
          <RectButton theme="blue" lock={!edited} working={STATUS_WORKING[item.status]} onClick={(e) => { this.saveField(conf, txt, val) }}>Save</RectButton>
        </div>
      </details>
    }
  }

  saveImage(conf, value, orig) {
    let item = dot(this.props.items);
    let field = conf.saveField || conf.field;
    this.saveField(conf, dot(value, "data.id"), dot(item, field));
  }

  saveField(conf, value, orig, index) {
    let modelProps = this.modelProps();
    let field = conf.saveField || conf.field;

    // Check for changes
    if (value == orig || (value == "" && orig == null)) { return; }

    // Get the latest item
    let item = dot(this.props.items);

    // Help prevent double entries
    if (dot(item, "status") == "creating") { return; }

    // Update values right away
    this.props.setItemField({ ...modelProps, field: field, value: value });

    // Get draft changes in case of multiple edits
    let draft = Draft.deep(dot(item, "data"));

    // Clear or set the new value
    if (conf.type == "date" && (!value || value == "")) {
      draft.clear(field)
    } else {
      draft.set(field, value);
    }

    this.setState({ statuses: { ...this.state.statuses, [index]: "saving" } });

    // Push the item
    let singular = singularType(modelProps);
    let links = dot(this.props, "query.links");
    this.props.qItem({
      ...modelProps,
      docs: { [singular]: draft.updates },
      query: {
        links: links ? links.join(",") : undefined,
        promptError: true
      },
      after: (res) => {
        let rd = dot(res, [singular, "data"]);
        if (dot(rd, "version") == 1) {
          let editing = this.state.editing;
          editing[dot(rd.id)] = true;
          this.setState({ editing: editing })
        }
        if (this.props.onItemPush) {
          this.props.onItemPush(dot(res, singular));
        }
        if (index !== undefined) {
          this.setState({ statuses: { ...this.state.statuses, [index]: "saved" } });
        }
      }
    });
  }

  saveDateField(conf, value, orig) {
    // Convert date to approprite format
    if (value && value.length > 0) {
      let date = Date.parseYMDStr(value);
      value = date.srvstr({ utc: true })
    }
    this.saveField(conf, value, orig);
  }

  onInputChange(e, dirty, index) {
    this.setFieldStatus(index, dirty ? "dirty" : null);
  }

  setFieldStatus(index, status) {
    this.setState({ statuses: { ...this.state.statuses, [index]: status } });
  }

  onDeleteItem(e) {
    let modelProps = this.modelProps();
    const id = dot(this.props.items, "data.id") || 0;
    if (id > 0) {
      this.props.deleteItem({ ...modelProps })
        .then(() => {
          this.props.purgeItem({ ...modelProps });
        });
    }
    else {
      this.props.purgeItem({ ...modelProps });
    }
    this.setState({ sci: null, notes: {} });
  }

  modelProps() {
    let props = this.props;
    return {
      type: props.type,
      typeAlias: props.typeAlias,
      id: props.id,
      idAlias: props.idAlias,
      childType: props.childType,
      childTypeAlias: props.childTypeAlias,
      childId: props.childId,
      index: props.index
    }
  }

  render() {
    const layout = this.props.layout || [];
    const item = this.props.item || {};
    const statuses = this.state.statuses || {};
    let editing = this.state.editing;
    let className = this.props.className || "";
    let trueId = dot(item, "data.id") || "stub";
    let keyPrefix = `fd-${this.props.type || 'model'}-${trueId}`;
    return (
      <div className={`FlexForm ${className}`} animate={item.status || null}>
        {layout.map((conf, i) => {
          let className = conf.className || (conf.title ? conf.title.replace(" ", "_") : "");
          return <div key={`${keyPrefix}-${i}`} className={`Fd${i} FlexField ${className}`} data-type={conf.type} data-hype={conf.hype} data-status={statuses[i] || null}>
            {conf.title ? <div className="Label">{conf.title}</div> : null}
            {(conf.readonly || !editing) ? this.renderReadOnlyField(item, conf, i) : this.renderField(item, conf, i)}
          </div>
        })}
      </div>
    );
  }
}

const mapState = (state, props) => {
  let item = stateForDoc(state.inventory, props) || {};
  return {
    item: item
  }
};

const mapDispatch = (dispatch) => {
  return {
    deleteItem: opts => dispatch(deleteItem(opts)),
    purgeItem: opts => dispatch(purgeItem(opts)),
    pushItem: opts => dispatch(pushItem(opts)),
    qItem: opts => dispatch(qItem(opts)),
    startDraftItem: opts => dispatch(startDraftItem(opts)),
    setItemField: opts => dispatch(setItemField(opts))
  }
};

export default connect(
  mapState,
  mapDispatch
)(FlexForm)
